import React from 'react';
import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import { SVGS } from '../assets';
import './registred-screen.scss';
import { SignUpContainer } from '../sign-up-container/sign-up-container';
import { SellerDetails } from '@zonofi/zo-types';

interface RegistredScreenProps {
  handleContinue: () => void;
  sellerDetails: SellerDetails;
  isLoading: boolean;
}

export const RegistredScreen: React.FC<RegistredScreenProps> = ({
  handleContinue,
  sellerDetails,
  isLoading,
}) => {
  return (
    <SignUpContainer customClass="custom register-screen">
      <div className="registredScreen">
        <div className="registred">
          <img src={SVGS.RegistredImage} width={130} height={129} />
        </div>
        <div className="reg_mid_sec">
          <h2 className="primary-font-semibold">Thank You!</h2>
          <p className="primary-font-regular">You're now signed up to ZöTok</p>
          {/* <p className="primary-font-regular">
            {`You signed up as a ${}`}
          </p> */}
        </div>

        <div className="seperator"></div>
        {/* <div className="launch-screen-plan-details">
          <div className="launch-screen-plan-details-top">
            <div className="launch-screen-plan-details-active-plan primary-font-semibold">
              On Demand
            </div>
            <div className="launch-screen-plan-details-status primary-font-regular">
              Active
            </div>
          </div>
        </div> */}
        <div className="details_bottomSec">
          <ZoButton
            label="Launch ZöTok"
            endIcon={
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={SVGS.RightArrowIcon}
                  width={20}
                  height={21}
                  className="ArrowRight"
                />
              </span>
            }
            isLoading={isLoading}
            onClick={handleContinue}
            className="sign-up-now-btn register"
          />
        </div>
      </div>
    </SignUpContainer>
  );
};
